import { useState } from "react";
import { MapPin } from "lucide-react";
import { fileUrl } from "@/lib/api";

/** Static map pin for a saved location. Degrades to the coordinates when the Maps image is unavailable. */
export const LocationPin = ({ geolocation, address, testId }) => {
  const [failed, setFailed] = useState(false);
  const lat = geolocation?.latitude;
  const lng = geolocation?.longitude;
  if (lat == null || lng == null) return null;

  return (
    <div className="mt-3 overflow-hidden rounded-xl border border-slate-200 bg-stone-50" data-testid={testId}>
      {failed ? (
        <p className="flex items-center gap-2 px-3 py-2.5 text-xs text-slate-500">
          <MapPin className="h-3.5 w-3.5 text-emerald-700" />
          {lat.toFixed(5)}, {lng.toFixed(5)}
        </p>
      ) : (
        <img
          src={fileUrl(`/api/maps/static?lat=${lat}&lng=${lng}`)}
          alt={address ? `Map of ${address}` : "Visit location"}
          className="h-40 w-full object-cover"
          loading="lazy"
          onError={() => setFailed(true)}
          data-testid={`${testId}-image`}
        />
      )}
    </div>
  );
};
